<template>
  <div style="width: 350px">
    <el-form size="small" label-position="left" label-width="90px" status-icon :model="formData" :rules="rules" ref="formData">
      <el-form-item prop="user_email" label="email">
        <el-input auto-complete="new-password" v-model="formData.user_email"></el-input>
      </el-form-item>
      <el-form-item prop="code" label="code">
        <el-input auto-complete="new-password" v-model="formData.code" style="width: 150px;float: left"></el-input><a href="#" @click="getCode()">PIN</a>
      </el-form-item>
      <el-form-item prop="user_password" label="password">
        <el-input type="password" v-model="formData.user_password"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input auto-complete="new-password" type="password" v-model="formData.password"></el-input>
      </el-form-item>
      <el-form-item align="right">
        <el-button @click="$emit('close')">back</el-button>
        <el-button class="el-button--primary" @click="submit('formData')">reset</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'ResetPassword',
    props:{
      close:Function
    },
    data(){
      return{
        formData:{
          user_email:'',
          user_password:'',
          code:'',
          password:'',
          authToken: ''
        },

        rules:{
          user_email:[
            {required:true,message:'please input your email!'},
            // {pattern:/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/,message:"please enter your vaild email!"}
            ],
          user_password:[
            {required:true,message:'please input password!'},
            /*{
              validator: (rule, value, callback) => {
                if(value!==this.formData.password){
                  callback(new Error("The two passwords are inconsistent!"))
                }
                callback()
              }
            }*/
            ],
          password:[
            {required:true,message:'please input password!'},
            {
              validator: (rule, value, callback) => {
                if(value!==this.formData.user_password){
                  callback(new Error("The two passwords are inconsistent!"))
                }
                callback()
              }
            }
          ],
          code:[{required:true,message:'please input E-mail verification code!'}],
        }
      }
    },
    methods:{
      getCode(){
        if(this.formData.user_email===''){
          this.$message.error('please input your email!')
          this.$refs['formData'].fields[0].validateMessage = 'please input your email!'
          this.$refs['formData'].fields[0].validateState = 'error'
        }else {
          let loading=this.$util.loading()
          this.$api.rootV1.post('/app/authcode/get',
            {user_email:this.formData.user_email,type:2},
            (result)=>{
                const {authToken} = result.data
                this.formData.authToken = authToken
              this.$alert( 'Email verification code sent successfully!','info', {
                confirmButtonText: 'confirm',
                type:'success',
                callback: action => {
                  loading.close()
                }
              })
            }, ()=>{
              this.$alert( 'Email verification code sent fail!','info', {
                confirmButtonText: 'confirm',
                type:'error',
                callback: action => {
                  loading.close()
                }
              })

            })
        }
      },
      submit(formName){
        this.$refs[formName].validate(
          (valid)=>{
            console.log(JSON.stringify(this.formData))
            if(valid){
              let loading=this.$util.loading()
              this.$api.rootV1.post('/web/user/password/update', this.formData,
                (res) => {
                  this.$alert( 'reset successfully!','info', {
                    confirmButtonText: 'confirm',
                    type:'success',
                    callback: action => {
                      loading.close()
                      this.$emit("close")
                    }
                  })
                }, (res) => {
                  this.$alert( 'reset fail!'+res.errmsg,'info', {
                    confirmButtonText: 'confirm',
                    type:'error',
                    callback: action => {
                      loading.close()
                    }
                  })
                })
            }else {
              this.$message.warning('Please check the input data!')
            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue